import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "lg:w-6/12 bg-gray-800 shadow-2xl rounded-lg overflow-hidden relative text-white" }
const _hoisted_2 = {
  id: "header-buttons",
  class: "py-3 px-4 flex relative"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-full w-3 h-3 bg-red-500 mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-full w-3 h-3 bg-yellow-500 mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-full w-3 h-3 bg-green-500" }, null, -1)
const _hoisted_6 = { class: "py-4 px-4 text-sm overflow-auto" }
const _hoisted_7 = { class: "mx-4 py-4 border-t-slate-400 border-t-[1px]" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { ref } from 'vue';
import ClipboardCopy from "./ClipboardCopy.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeViewer',
  props: {
    code: {},
    details: {}
  },
  setup(__props: any) {



const codeContainer = ref<HTMLElement>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(ClipboardCopy, { container: codeContainer.value }, null, 8, ["container"])
    ]),
    _createElementVNode("article", _hoisted_6, [
      _createElementVNode("pre", {
        ref_key: "codeContainer",
        ref: codeContainer
      }, _toDisplayString(_ctx.code), 513)
    ]),
    _withDirectives(_createElementVNode("aside", _hoisted_7, [
      (Array.isArray(_ctx.details))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "my-2",
                key: index
              }, _toDisplayString(detail.value), 1))
            }), 128))
          ]))
        : (typeof _ctx.details === 'object')
          ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (value, key) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  class: "my-2"
                }, _toDisplayString(key) + ": \"" + _toDisplayString(value) + "\" ", 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_ctx.details), 1)
            ], 64))
    ], 512), [
      [_vShow, _ctx.details]
    ])
  ]))
}
}

})